import React from "react";

const SmartImage = ({
  src,
  alt,
  className = "",
  style = {},
  width,
  height,
  crop = "fill",
  gravity = "center",
  webpFallback = true,
  highQuality = false,
  ...props
}) => {
  const cloudName = process.env.REACT_APP_CLOUDINARY_NAME;

  if (!cloudName) {
    console.warn("REACT_APP_CLOUDINARY_NAME not set");
    return <img src={src} alt={alt} className={className} {...props} />;
  }

  // Clean public ID (remove leading slash if present)
  const publicId = src.startsWith("/") ? src.substring(1) : src;

  // Build URLs based on quality mode
  const baseUrl = `https://res.cloudinary.com/${cloudName}/image/upload`;

  let webpUrl, jpgUrl;
  if (highQuality) {
    // High quality mode: minimal transformations, best quality
    const qualityTransformations = ["q_auto:best"];
    const transformString = qualityTransformations.join(",");

    webpUrl = `${baseUrl}/${transformString}/f_webp/${publicId}`;
    jpgUrl = `${baseUrl}/${transformString}/${publicId}`; // Original format
  } else {
    // Standard mode: apply all transformations
    const transformations = [];
    if (width) transformations.push(`w_${width}`);
    if (height) transformations.push(`h_${height}`);
    if (crop) transformations.push(`c_${crop}`);
    if (gravity && crop !== "scale") transformations.push(`g_${gravity}`);

    const transformString = transformations.length
      ? `${transformations.join(",")}/`
      : "";

    webpUrl = `${baseUrl}/${transformString}f_webp/${publicId}`;
    jpgUrl = `${baseUrl}/${transformString}f_jpg/${publicId}`;
  }


  if (webpFallback) {
    return (
      <picture>
        <source srcSet={webpUrl} type="image/webp" />
        <img
          src={jpgUrl}
          alt={alt}
          className={className}
          style={style}
          loading="lazy"
          onError={(e) => console.error("Failed to load:", jpgUrl)}
          {...props}
        />
      </picture>
    );
  }

  return (
    <img
      src={jpgUrl}
      alt={alt}
      className={className}
      style={style}
      loading="lazy"
      onError={(e) => console.error("Failed to load:", jpgUrl)}
      {...props}
    />
  );
};

export default SmartImage;
